import styled from '@emotion/styled'
import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import { theme } from 'styles/theme/hav-theme'

type StyledMenuProps = {
  minwidth?: number
}
export const StyledButton = styled(Button)`
  text-transform: none;
  height: 35px;
  padding: 0 ${theme.spacing.sm};
  border-radius: ${theme.shapes.borderRadius.sm};
  border: 1px solid rgba(255, 255, 255, 0.5);
  background: rgba(255, 255, 255, 0.25);

  font-size: ${theme.typography.sizes.xs};
  font-weight: ${theme.typography.weight.sm};
  line-height: ${theme.typography.lineHeight.sm};

  :hover {
    background-color: rgba(255, 255, 255, 0.1);
    font-weight: ${theme.typography.weight.lg};
  }
`

export const StyledMenu = styled(Menu)<StyledMenuProps>`
  & .MuiPaper-root {
    min-width: ${({ minwidth }) => `${minwidth}px` || 'auto'};
    border-radius: ${theme.shapes.borderRadius.sm};
    margin-top: ${theme.spacing.xs};
    box-shadow: 0px 1px 3px 0px rgba(51, 69, 96, 0.2);

    & .MuiMenu-list {
      padding: 8px 0;
    }

    & .MuiMenuItem-root {
      padding: 0 ${theme.spacing.md};
      height: 32px;

      font-size: ${theme.typography.sizes.xs};
      font-family: ${theme.typography.family.bold};
      line-height: ${theme.typography.lineHeight.sm};

      & .MuiSvgIcon-root {
        font-size: ${theme.typography.sizes.md};
        margin-right: ${theme.spacing.sm};
      }
    }
  }
`
